export default __webpack_public_path__ + "static/media/1283.dcc7b0ef.png";